export const headers = [
	{
		width: '46px',
		text: "Id",
		value: "id",
		sortable: true,
		footer: "count",
	},
	{
		width: '110px',
		text: "Time",
		value: "time",
		sortable: true,
		modValue: 'dateTime'
	},
	{
		text: "Name",
		value: "user",
		sortable: true
	},
	{
		text: "Note",
		value: "description",
		sortable: true
	},
];
